//Base url for axios/API
export const BASE_URL = process.env.REACT_APP_API ? process.env.REACT_APP_API : 'http://localhost:3000/api'
export const BASE_AUTH_URL = process.env.REACT_APP_AUTH_API ? process.env.REACT_APP_AUTH_API : 'http://localhost:3000/ids'
//export const BASE_AUTH_URL = process.env.REACT_AUTH_API ? process.env.REACT_AUTH_API : 'https://sac-ids-qa.azurewebsites.net'
//export const TEMP_FARM_ID = process.env.TEMP_FARM_ID ? process.env.TEMP_FARM_ID : 'DFF8E95E-A8BC-46A2-A71F-78F526FEB059'
export const APP_CLIENT_ID = process.env.APP_CLIENT_ID ? process.env.APP_CLIENT_ID : 'AgreCalc_Swagger'
export const APP_SCOPE = process.env.APP_SCOPE ? process.env.APP_SCOPE : 'AgreCalc'
